import { useTranslation } from 'react-i18next';

import EmployerInput from './EmployerInput';
import PhoneInput from '../../PhoneInput';
import { GroupInputs } from '../../GroupInputs';

import styles from './index.module.css';

interface Props {
  value?: string;
  collectEmployerPhoneNumber: boolean;
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
}

export default function Employer({
  value,
  collectEmployerPhoneNumber,
  saveFieldValue,
  updateFieldValue,
}: Props) {
  const { t } = useTranslation();
  const oldEmployer = value ? JSON.parse(value) : {};
  const { employer, employerRaw, employerPhone } = oldEmployer;
  const employerUpdate = (update: { [key: string]: string }) => {
    const newEmployer = { ...oldEmployer, ...update };
    return JSON.stringify(newEmployer);
  };
  const employerInputs = [
    {
      label: t('Employer name'),
      labelFor: 'employer-name',
      element: (
        <EmployerInput
          id="employer-name"
          value={{ employer, employerRaw }}
          onChange={(newValue) => {
            updateFieldValue(
              employerUpdate({
                employer: newValue.employer ?? '',
                employerRaw: newValue.employerRaw ?? '',
              }),
            );
            saveFieldValue(
              employerUpdate({
                employer: newValue.employer ?? '',
                employerRaw: newValue.employerRaw ?? '',
              }),
            );
          }}
        />
      ),
    },
  ];
  if (collectEmployerPhoneNumber) {
    employerInputs.push({
      label: t('employersPhoneNumber'),
      labelFor: 'employer-phone',
      element: (
        <PhoneInput
          label={t('employersPhoneNumber')}
          id="employer-phone"
          value={employerPhone || ''}
          placeholder=" "
          updateFieldValue={(newValue) =>
            updateFieldValue(employerUpdate({ employerPhone: newValue }))
          }
          saveFieldValue={(newValue) =>
            saveFieldValue(employerUpdate({ employerPhone: newValue }))
          }
        />
      ),
    });
  }

  return <GroupInputs inputs={employerInputs} classNames={[styles.FormDiv]} />;
}
